// Países de Latinoamérica con códigos telefónicos
export const latinAmericaCountries = [
  {
    code: 'MX',
    name: 'México',
    dialCode: '+52',
    flag: '🇲🇽',
    phoneFormat: 'XXX XXX XXXX',
    phoneLength: 10
  },
  {
    code: 'GT',
    name: 'Guatemala',
    dialCode: '+502',
    flag: '🇬🇹',
    phoneFormat: 'XXXX XXXX',
    phoneLength: 8
  },
  {
    code: 'HN',
    name: 'Honduras',
    dialCode: '+504',
    flag: '🇭🇳',
    phoneFormat: 'XXXX XXXX',
    phoneLength: 8
  },
  {
    code: 'SV',
    name: 'El Salvador',
    dialCode: '+503',
    flag: '🇸🇻',
    phoneFormat: 'XXXX XXXX',
    phoneLength: 8
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    dialCode: '+505',
    flag: '🇳🇮',
    phoneFormat: 'XXXX XXXX',
    phoneLength: 8
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    dialCode: '+506',
    flag: '🇨🇷',
    phoneFormat: 'XXXX XXXX',
    phoneLength: 8
  },
  {
    code: 'CU',
    name: 'Cuba',
    dialCode: '+53',
    flag: '🇨🇺',
    phoneFormat: 'XXXX XXXX',
    phoneLength: 8
  },
  {
    code: 'PA',
    name: 'Panamá',
    dialCode: '+507',
    flag: '🇵🇦',
    phoneFormat: 'XXXX XXXX',
    phoneLength: 8
  },
  {
    code: 'CO',
    name: 'Colombia',
    dialCode: '+57',
    flag: '🇨🇴',
    phoneFormat: 'XXX XXX XXXX',
    phoneLength: 10
  },
  {
    code: 'VE',
    name: 'Venezuela',
    dialCode: '+58',
    flag: '🇻🇪',
    phoneFormat: 'XXX XXX XXXX',
    phoneLength: 10
  },
  {
    code: 'EC',
    name: 'Ecuador',
    dialCode: '+593',
    flag: '🇪🇨',
    phoneFormat: 'XX XXX XXXX',
    phoneLength: 9
  },
  {
    code: 'PE',
    name: 'Perú',
    dialCode: '+51',
    flag: '🇵🇪',
    phoneFormat: 'XXX XXX XXX',
    phoneLength: 9
  },
  {
    code: 'BO',
    name: 'Bolivia',
    dialCode: '+591',
    flag: '🇧🇴',
    phoneFormat: 'X XXX XXXX',
    phoneLength: 8
  },
  {
    code: 'CL',
    name: 'Chile',
    dialCode: '+56',
    flag: '🇨🇱',
    phoneFormat: 'X XXXX XXXX',
    phoneLength: 9
  },
  {
    code: 'AR',
    name: 'Argentina',
    dialCode: '+54',
    flag: '🇦🇷',
    phoneFormat: 'XX XXXX XXXX',
    phoneLength: 10
  },
  {
    code: 'UY',
    name: 'Uruguay',
    dialCode: '+598',
    flag: '🇺🇾',
    phoneFormat: 'XX XXX XXX',
    phoneLength: 8
  },
  {
    code: 'PY',
    name: 'Paraguay',
    dialCode: '+595',
    flag: '🇵🇾',
    phoneFormat: 'XXX XXX XXX',
    phoneLength: 9
  },
  {
    code: 'BR',
    name: 'Brasil',
    dialCode: '+55',
    flag: '🇧🇷',
    phoneFormat: 'XX XXXXX XXXX',
    phoneLength: 11
  }
];

// Función helper para formatear número según país
export const formatPhoneNumber = (number, countryCode) => {
  const country = latinAmericaCountries.find(c => c.code === countryCode);
  if (!country) return number;
  
  // Remover todo excepto dígitos
  const digits = number.replace(/\D/g, '');
  
  // Aplicar formato
  let formatted = '';
  let digitIndex = 0;
  
  for (let i = 0; i < country.phoneFormat.length; i++) {
    if (country.phoneFormat[i] === 'X') {
      if (digitIndex < digits.length) {
        formatted += digits[digitIndex];
        digitIndex++;
      }
    } else {
      formatted += country.phoneFormat[i];
    }
  }
  
  return formatted;
};

// Función para validar número según país
export const validatePhoneNumber = (number, countryCode) => {
  const country = latinAmericaCountries.find(c => c.code === countryCode);
  if (!country) return false;
  
  const digits = number.replace(/\D/g, '');
  return digits.length === country.phoneLength;
};

// Función para obtener número completo con código
export const getFullPhoneNumber = (number, countryCode) => {
  const country = latinAmericaCountries.find(c => c.code === countryCode);
  if (!country) return number;
  
  const digits = number.replace(/\D/g, '');
  return `${country.dialCode}${digits}`;
};
